module.exports = __webpack_public_path__ + "img/panama.7cd25ce9.svg";